import { Client } from "@stomp/stompjs";
import { useAppStore } from "~stores/App.ts";
import { useUserStore } from "~stores/User.ts";
import { markNotificationAsRead } from "@q-food/q-food";

let socketUrl;
if (import.meta.env.VITE_QFOOD_WEBSOCKET_HOST == undefined || import.meta.env.VITE_QFOOD_WEBSOCKET_HOST == "") {
	socketUrl = `wss://${window.location.host}`;
} else {
	socketUrl = import.meta.env.VITE_QFOOD_WEBSOCKET_HOST;
}

const socketClient = new Client({
	brokerURL: `${socketUrl}/ws`,
	heartbeatOutgoing: 10_000,
	connectHeaders: {
		"x-auth-token": localStorage.getItem("qfood-session-token")!,
	},
});

const onConnectListeners: ((client: Client) => void)[] = [];

export function onConnect(func: (client: Client) => void) {
	if (socketClient.active && socketClient.connected) {
		func(socketClient);
	}

	onConnectListeners.push(func);
}

socketClient.onConnect = (frame) => {
	const { toast } = useToast();

	onConnectListeners.forEach((listener) => listener(socketClient));

	socketClient.subscribe("/user/channel/notifications", async (msg) => {
		const notification = JSON.parse(msg.body);
		const type = (notification.type as string).toLowerCase();

		if (!(type in toast)) {
			return;
		}

		await new Promise((r) => setTimeout(r, 300));

		const userStore = useUserStore();
		await userStore.refreshNotifications();

		window.dispatchEvent(new CustomEvent("food:notification", { detail: notification }));
		toast[type](notification.title, {
			description: notification.message,
			onDismiss: async () => {
				if (notification.details.length === 0 && notification.priority === false) {
					await userStore.readNotification(notification);
				}
			},
		});
	});

	socketClient.subscribe("/user/channel/refresh-app", (msg) => {
		useAppStore().refreshApp();
	});
};

export { socketClient };
